import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import DialogDetalhePedido from './DialogDetalhePedido';
import useSetParamsURL from '../../../../lib/useSetParamsURL';

interface ModalContextType {
    openModal: (content: string) => void;
    closeModal: () => void
}

const ModalDetalhePedidoContext = createContext<ModalContextType | undefined>(undefined);

export const ModalDetalhePedidoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const { searchParams, clearSingleParamUrl, setParamsUrl } = useSetParamsURL();
    const codigo = searchParams.get('detalhe-pedido')

    const [isOpen, setIsOpen] = useState(Boolean(codigo));
    const [itemValue, setItemValue] = useState<string | null>(codigo);

    const openModal = (content: string) => {
        setItemValue(content);
        setIsOpen(true);
        setParamsUrl(content, "detalhe-pedido")
    };

    const closeModal = () => {
        setIsOpen(false);
        setItemValue(null);
        clearSingleParamUrl("detalhe-pedido")
    };

    useEffect(() => {
        if (codigo) setItemValue(codigo)
    }, [codigo])

    return (
        <ModalDetalhePedidoContext.Provider value={{ openModal, closeModal }}>
            {children}

            {
                (itemValue && isOpen) &&
                <DialogDetalhePedido
                    open={isOpen}
                    value={itemValue}
                    handleClose={closeModal}
                />
            }
        </ModalDetalhePedidoContext.Provider>
    );
};

// Hook para usar o contexto
export const useModalDetalhePedido = (): ModalContextType => {
    const context = useContext(ModalDetalhePedidoContext);
    if (!context) throw new Error('useModal must be used within a ModalProvider');
    return context;
};